export default {
    methods: {
        resetLoanTerm() {
            this.LoanTerm = this.loanTermSlider.max < this.LoanTerm
                ? this.loanTermSlider.max
                : this.loanTermSlider.min > this.LoanTerm
                    ? this.loanTermSlider.min
                    : this.LoanTerm;
        },
        resetInterestRateVal() {
            this.InterestRate = this.interestRateSlider.max < this.InterestRate
                ? this.interestRateSlider.max
                : this.interestRateSlider.min > this.InterestRate
                    ? this.interestRateSlider.min
                    : this.InterestRate;
        },
        resetLoanAmtVal() {
            this.LoanAmount = this.loanAmtSlider.max < this.LoanAmount
                ? this.loanAmtSlider.max
                : this.loanAmtSlider.min > this.LoanAmount
                    ? this.loanAmtSlider.min
                    : this.LoanAmount;
        },
    },
};
